import { BaseComponent } from '../base-component'
import { isEnterKey } from '../../utils/key'
import { ModalComponent } from './modal'
import { $el } from 'src/scripts/utils/utils'

export class ModalButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.trigger()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.trigger()
    }
  }

  trigger() {
    const modal: ModalComponent = $el(this.dataset.modal, document)

    if (modal) {
      switch (this.dataset.action) {
        case 'close':
          modal.hide()
          return
        case 'open':
          modal.show()
          return
        case 'toggle':
          modal.toggle()
          return
      }
    }

    this.emit('click', {})
  }
}
